import { createEntityAdapter } from '@reduxjs/toolkit';

import { Slot } from 'modules/kiosk/types/Slot';
import { ReadySelfService } from 'modules/kiosk/types/GetReadySelfServices';

export const slotsAdapter = createEntityAdapter<Slot>();
export const selfServicesAdapter = createEntityAdapter<ReadySelfService>();
